// dev-portal/src/pages/auth/DentuluCallback.jsx

import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { api } from '../../api/client';

export default function DentuluCallback() {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [error, setError] = useState('');

    useEffect(() => {
        const handleCallback = async () => {
            try {
                // Get parameters from Dentulu SSO
                const userId = searchParams.get('user_id');
                const email = searchParams.get('email');
                const firstName = searchParams.get('first_name');
                const lastName = searchParams.get('last_name');
                const signature = searchParams.get('signature');
                const timestamp = searchParams.get('timestamp');
                const flow = searchParams.get('flow') || localStorage.getItem('dentulu_sso_flow') || 'login';
                
                // Get stored role (for signup flow)
                const role = localStorage.getItem('dentulu_sso_role') || 'developer';
                
                if (!userId || !email || !signature || !timestamp) {
                    setError('Invalid SSO response');
                    setTimeout(() => navigate(flow === 'signup' ? '/signup' : '/login'), 2000);
                    return;
                }

                // Send to backend for verification
                const response = await api.post('/api/sso/callback', {
                    user_id: parseInt(userId),
                    email,
                    first_name: firstName,
                    last_name: lastName,
                    role,
                    signature,
                    timestamp: parseInt(timestamp)
                });

                // Store token and navigate
                localStorage.setItem('token', response.data.access_token);
                localStorage.setItem('role', response.data.user.role);
                localStorage.removeItem('dentulu_sso_role');
                localStorage.removeItem('dentulu_sso_flow');

                window.location.href = '/dashboard';
            } catch (err) {
                console.error('SSO callback error:', err);
                setError(err.response?.data?.detail || 'Authentication failed');
                const flow = searchParams.get('flow') || 'login';
                setTimeout(() => navigate(flow === 'signup' ? '/signup' : '/login'), 3000);
            }
        };

        handleCallback();
    }, [searchParams, navigate]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-100">
            <div className="bg-white p-8 rounded-lg shadow-md text-center">
                {error ? (
                    <>
                        <div className="text-red-600 text-lg font-semibold mb-4">
                            {error}
                        </div>
                        <p className="text-gray-600">Redirecting to signup...</p>
                    </>
                ) : (
                    <>
                        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
                        <p className="text-gray-600">Completing authentication...</p>
                    </>
                )}
            </div>
        </div>
    );
}